<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
             :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>{{ title }}</div>
      <div>
        <el-button v-if="title!=='审核入库单'" type="primary" @click="submit"> 保存</el-button>
        <el-button v-else type="primary" @click="submit"> 确认入库</el-button>
        <el-button @click="$emit('close')"> 返回</el-button>
      </div>
    </div>
    <el-card class="udi-form group-box no-border" shadow="never">
      <div v-if="tips" class="tips">{{ tips }} <el-button type="text" @click="goProduct">去关联</el-button></div>
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <div class="box-title">单据信息</div>
        <el-form-item label="单据编号" prop="inCode">
          <el-input v-model="form.inCode" maxlength="50" placeholder="请输入单据编号"></el-input>
        </el-form-item>
        <el-form-item label="单据类型" prop="inType">
          <el-select v-model="form.inType" disabled placeholder="" clearable>
            <el-option v-for="dict in dictObj.inType" :key="dict.dictValue" :label="dict.dictLabel"
                       :value="dict.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请部门" prop="applyOrgName">
          <el-select v-model="form.applyOrgName" v-maxlength="20" filterable remote reserve-keyword
                     :remote-method="remoteMethodOrg" :loading="remoteLoading" placeholder="" allow-create clearable>
            <el-option v-for="item in applyList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="入库方式" prop="inWay">
          <el-select v-model="form.inWay" disabled placeholder="" clearable>
            <el-option v-for="dict in dictObj.warehouseType" :key="dict.dictValue" :label="dict.dictLabel"
                       :value="dict.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生产组织" prop="workOrgName">
          <el-input v-model="form.workOrgName" maxlength="30" placeholder="请输入生产组织"></el-input>
        </el-form-item>
        <el-form-item label="生产车间" prop="workshop">
          <el-input v-model="form.workshop" maxlength="30" placeholder="请输入生产车间"></el-input>
        </el-form-item>

        <el-form-item :label="title==='审核入库单' ? '选择生产订单' : '订单编号'" prop="bizName">
          <el-input v-model="form.bizName" disabled maxlength="50" placeholder=""></el-input>
        </el-form-item>
        <div class="box-title">入库产品</div>
        <el-button v-if="title!=='审核入库单'" style="margin-bottom: 12px;" type="primary" @click="selectDialog = true">选择产品</el-button>
        <el-table ref="dataTable" align="center" :data="form.productList">
          <el-table-column show-overflow-tooltip prop="materialName" label="物料名称"/>
          <el-table-column show-overflow-tooltip prop="specification" label="物料规格型号"/>
          <el-table-column show-overflow-tooltip prop="productName" label="产品名称"/>
          <el-table-column show-overflow-tooltip prop="productSpecification" label="产品规格型号"/>
          <el-table-column show-overflow-tooltip prop="diCode" label="产品DI"/>
          <el-table-column show-overflow-tooltip prop="materialCode" label="物料编码"/>
          <el-table-column show-overflow-tooltip prop="prodDate" label="生产日期"/>
          <el-table-column show-overflow-tooltip prop="expiryDate" label="失效日期"/>
          <el-table-column show-overflow-tooltip prop="batchNumber" label="批号"/>
          <el-table-column label="入库仓库">
            <template slot-scope="{row, $index }">
              <el-form-item :rules="rules.warehouseId" label="" :prop="`productList.${$index}.warehouseId`">
                <el-select v-model="row.warehouseId" filterable placeholder="" clearable
                           @change="($event) => { wareHouseChange($index, $event) }">
                  <el-option v-for="item in wareHouseList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="入库数量" width="150">
            <template slot-scope="{row, $index }">
              <template v-if="title === '审核入库单'">
                <el-form-item
                  v-if="row.isBatchCode"
                  :rules="rules.number"
                  label=""
                  :prop="`productList.${$index}.number`">
                  <el-input-number
                    v-model.number="row.number"
                    size="small"
                    :min="1"
                    :max="row.inNumber"
                    label="请输入入库数量"/>
                </el-form-item>
                <span v-else>{{ row.number }}</span>
              </template>
              <el-form-item v-else :rules="rules.number" label="" :prop="`productList.${$index}.number`">
                <el-input v-model.number="row.number" maxlength="6" placeholder="请输入入库数量"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="packLevel" label="包装单位"/>
          <el-table-column show-overflow-tooltip label="操作">
            <template slot-scope="{ $index, row }">
              <el-button v-if="title === '审核入库单'" type="size" @click="handleReviewUdi(row)">查看UDI码</el-button>
              <el-button v-else type="size" @click="remoteGoods($index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-card>
    <productSelect v-if="selectDialog" :visible="selectDialog" :product-list="form.productList" @getData="getData"
                   @update:loading="loading = $event" @close="selectDialog = false"/>
    <udiCheckReview
      v-if="previewVisible"
      :visible="previewVisible"
      :id="previewInfo.id"
      :isBatchCode="previewInfo.isBatchCode"
      @close="previewVisible = false"
      @removeUdi="handleRemoveUdi"
    />
  </el-drawer>
</template>

<script>
import productSelect from './productSelect'
import {
  addWarehousingOrder,
  updateWarehousingOrder,
  getWarehousingOrderInfo,
  auditWarehousingOrder
} from "@/api/warehousingOrder";
import {getOrg} from '@/api/orderManage'

import {getWareHouse} from '@/api/warehouse'
import debounce from 'lodash/debounce'
import UdiCheckReview from "@/views/warehouseManage/components/udiCheckReview.vue";

export default {
  name: 'AddOrder',
  components: { UdiCheckReview, productSelect,},
  computed: {
    title() {
      if (this.orderInfo.inWay === 'scanStore') {
        return this.orderInfo.orderId ? '编辑入库单' : '创建入库单'
      } else if (['directStockIn', 'packConnectStockIn'].includes(this.orderInfo.inWay)) {
        return '审核入库单'
      }
      return '创建入库单'
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    orderInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          bizType: [],
          saleOrderType: [],
          inType: []
        }
      }

    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      selectDialog: false,
      categoryData: [],
      wareHouseList: [],
      remoteLoading: false,
      applyList: [],
      tips: undefined,
      form: {
        inCode: null,
        inType: 'productionReceipt',
        applyOrgName: null,
        inWay: 'scanStore',
        workshop: null,
        workOrgName: null,
        bizId: null,
        bizName: null,
        productList: [],
      },
      backForm: {
        inCode: null,
        inType: 'productionReceipt',
        applyOrgName: null,
        inWay: 'scanStore',
        workshop: null,
        workOrgName: null,
        bizId: null,
        bizName: null,
        productList: [],
      },
      previewVisible: false,
      previewInfo: {},
      rules: {
        inCode: [
          {
            required: true,
            message: '请输入单据编号',
            trigger: ['change', 'blur']
          },
          {
            pattern: /^[a-zA-Z0-9\-_!@#$%^&*()+]+$/,
            message: '仅能输入数字、字符、大小写字母',
          }
        ],
        inType: [
          {
            required: true,
            message: '请选择单据类型',
            trigger: ['change', 'blur']
          }

        ],
        applyOrgName: [
          {
            required: true,
            message: '请输入申请部门',
            trigger: ['change', 'blur']
          }
        ],
        warehouseId: [
          {
            required: true,
            message: '请选择入库仓库',
            trigger: ['change', 'blur']
          }
        ],
        number: [
          {
            required: true,
            message: '请输入入库数量',
            trigger: ['change', 'blur']
          },
          {
            pattern: /^[0-9]\d*$/,
            message: '请输入整数',
            trigger: ['change', 'blur']
          },
        ],
        inWay: [
          {
            required: true,
            message: '请选择入库方式',
            trigger: ['change', 'blur']
          }
        ],
        bizName: [
          {
            required: true,
            message: '请选择生产订单',
            trigger: ['change', 'blur']
          }
        ],
      }
    }
  },
  created() {
    this.getWareHouse()
    if (this.orderInfo.id) {
      this.getOrderInfo(this.orderInfo)
    }
  },
  // 方法集合
  methods: {
    remoteMethodOrg: debounce(
      function (name) {
        if (name !== '') {
          this.remoteLoading = true
          // 获取已有客户名称
          getOrg({name}).then((res) => {
            this.applyList = res.data
            this.remoteLoading = false
          })
            .catch(() => {
              this.remoteLoading = false
              this.applyList = []
            })
        } else {
          this.applyList = []
        }
      },
      500,
      {
        leading: true, // 延长开始后调用
        trailing: false // 延长结束前调用
      }
    ),
    // 获取入库仓库
    getWareHouse() {
      getWareHouse().then((res) => {
        this.wareHouseList = res.rows
      })
    },
    // 仓库更改
    wareHouseChange(index, value) {
      const find = this.wareHouseList.find(item => item.id === value);
      if (this.form.productList.filter(item => item.warehouseId === value && item.diCode === this.form.productList[index].diCode).length > 1) {
        this.$message.error('同任务同产品不可在相同仓库入库')
        this.form.productList[index].warehouseName = null
        this.form.productList[index].warehouseId = null
        return
      }
      this.form.productList[index].warehouseName = find.name
    },
    // 获取单据信息
    getOrderInfo({id}) {
      this.orderId = id
      // 获取基础信息数据
      this.loading = true
      getWarehousingOrderInfo(id).then(res => {
        // 转换数据
        for (const key in this.form) {
          if (res.data[key]) {
            this.form[key] = res.data[key]
            // 用于审核入库单时数据对比
            this.backForm[key] = res.data[key]
          }
        }
        const arr = [] // 未关联物料编码的产品列表
        this.form.productList.forEach((item) => {
          if (!item.materialCode) {
            arr.push(item.diCode)
          }
        })
        if (arr.length>0) {
          this.tips = `请先关联产品【${arr.join('、')}】的物料`
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // 对比入库单数据是否修改
    checkData() {
      return Object.keys(this.backForm).some(key => {
        if (key === 'productList') {
          return this.form[key].some((item, index) => {
            return this.backForm[key][index].number !== item.number || this.backForm[key][index].warehouseId !== item.warehouseId
          })
        }
        return this.form[key] !== this.backForm[key]
      })
    },
    // 处理弹窗DI确认选择
    getData(data) {
      if (!!this.form.bizId && this.form.bizId !== data.taskId) {
        // console.log(this.form.productList);
        this.$message.error('请选择同任务下不同产品')
      } else {
        const {
          diCode,
          prodDate,
          packLevel,
          materialCode,
          expiryDate,
          batchNumber,
          productName,
          productSpecification,
          materialName,
          specification,
          taskId,
          productId,
          taskName
        } = data
        this.form.productList.push({
          diCode,
          productId,
          prodDate,
          expiryDate,
          batchNumber,
          productName,
          productSpecification,
          materialName,
          specification,
          materialCode,
          packLevel,
          number: null,
          warehouseName: null,
          warehouseId: null
        })
        this.form.bizName = taskName
        this.form.bizId = taskId
        this.selectDialog = false
      }
    },
    // 处理删除
    remoteGoods(index) {
      this.form.productList.splice(index, 1)
      if (this.form.productList.length === 0) {
        this.form.bizId = null
        this.form.bizName = null
      }
    },
    submitCallback() {
      const params = JSON.parse(JSON.stringify(this.form));
      this.loading = true
      if (!this.orderInfo.id) {
        addWarehousingOrder(params).then(() => {
          this.$emit('close')
        }).finally(() => {
          this.loading = false
        })
      } else {
        if (this.title === '审核入库单') {
          auditWarehousingOrder({...params, id: this.orderInfo.id}).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        } else { // 修改入库单
          updateWarehousingOrder({...params, id: this.orderInfo.id}).then(() => {
            this.$emit('close')
          }).finally(() => {
            this.loading = false
          })
        }

      }
    },
    // 保存
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        if (this.form.productList.length === 0) {
          this.$message.error('入库产品不能为空')
          return
        }
        const arr = [] // 未关联物料编码的产品列表
        this.form.productList.forEach((item, index) => {
          if (!item.materialCode) {
            arr.push(item.diCode)
          }
        })
        if (arr.length>0) {
          this.$message.error(`请先关联产品【${arr.join('、')}】的物料`)
          return;
        }
        // 非审核订单直接提交
        if (this.title === '审核入库单' && this.checkData()) {   //  审核订单需判读是否更改了参数
          this.$confirm('当前入库信息已修改，您确认要直接入库吗？').then(() => {
            this.submitCallback()
          })
        } else {
          this.submitCallback()
        }
      })
    },
    // 删除UDI处理
    handleRemoveUdi(row, total) {
      // 如果需要基于原始数据进行删除，你需要先找到这个 row 在 rawData 中的索引
      const findIndex = this.form.productList.findIndex(
        (item) => item.diCode === this.previewInfo.diCode
      )
      this.form.productList[findIndex].inNumber = total
      this.form.productList[findIndex].number = total
    },
    // 查看UDI码
    handleReviewUdi(row) {
      this.previewVisible = true
      this.previewInfo = row
    },
    goProduct() {
      this.$router.push('/material')
    }
  }
}
</script>

<style scoped>
.group-box .el-table :deep(.el-form-item) {
  margin-bottom: 0 !important;
}
.tips{
  padding: 10px;
  color: rgb(255, 150, 50);
  background-color: rgb(253, 246, 236);
  border-radius: 3px;
}
</style>
